import styled from "styled-components";
import ToggleButton from '@mui/material/ToggleButton';
export const StyledToggleButton = styled(ToggleButton)``;
